import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { CarePlanItemCardComponent } from '../../shared/care-plan-item-card/care-plan-item-card.component';
import { OutcomeCard } from '../api/outcome-api.model';

@Component({
  selector: 'bn-outcome-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarePlanItemCardComponent, CurrencyPipe, DatePipe],
  templateUrl: './outcome-card.component.html',
  styleUrl: './outcome-card.component.scss',
})
export class OutcomeCardComponent {
  readonly outcome = input.required<OutcomeCard>();
  readonly typeLabel = input.required<string>();
  readonly editable = input(false);
  readonly disabled = input(false);
  readonly title = computed(
    () =>
      this.outcome().name?.trim() ||
      this.outcome().description?.trim() ||
      this.typeLabel(),
  );
  readonly openOutcome = output<OutcomeCard>();
}
